import React from 'react';
import PropTypes from 'prop-types';
import { IconButton, Tooltip } from '@material-ui/core';
import CookieIcon from '@material-ui/icons/Tune';

const ConsentModalToggle = ({ onClick }) => {
  return (
    <Tooltip title="Consent Settings" arrow>
      <IconButton
        data-test-id="consent-modal-toggle"
        onClick={onClick}
        aria-label="toggle cookie modal"
        style={{
          position: 'absolute',
          bottom: 16,
          right: 16,
        }}
      >
        <CookieIcon />
      </IconButton>
    </Tooltip>
  );
};

ConsentModalToggle.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default ConsentModalToggle;
